import React from 'react';
import type { FC } from 'react';
import { TextInput } from '@wix/cli-ui-kit';
import { useTranslation } from '@wix/cli-i18n';
import { useBackendComponents } from '../../../backend/useBackendComponents.js';
import {
  composeValidations,
  pathValidation,
  useValidation,
} from '../../../dev-center/components/validations/index.js';
import { useWixCliAppBi } from '../../../bi/index.js';

import { useWizardStep } from '../Wizard.js';

export const ChooseFolderStep: FC<{
  eventFolder?: string;
  onSubmit: (value: string) => void;
}> = ({ onSubmit, eventFolder }) => {
  const bi = useWixCliAppBi();
  const { t } = useTranslation();
  const { backendComponentsByType } = useBackendComponents();
  const { isActive, goToNextStep } = useWizardStep();

  const events = backendComponentsByType.Event;
  const validateEventFolder = useValidation(
    composeValidations([
      [
        (folderName: string) =>
          events.every((event) => event.title !== folderName) &&
          pathValidation(folderName),
        t('generate_command.event.choose_folder.error'),
      ],
    ])
  );

  return (
    <TextInput
      isActive={isActive}
      label={t('generate_command.event.choose_folder')}
      placeholder={
        eventFolder ?? t('generate_command.event.folder_placeholder')
      }
      onSubmit={(value) => {
        bi.cliFlowStepAnswered({
          question: t('generate_command.event.choose_folder'),
          questionKey: 'generate_command.event.choose_folder',
          answer: value,
        });
        onSubmit(value);
        goToNextStep();
      }}
      validate={validateEventFolder}
    />
  );
};
